<header class="MuiPaper-root MuiPaper-elevation MuiPaper-elevation4 MuiAppBar-root MuiAppBar-colorPrimary MuiAppBar-positionFixed mui-fixed mui-style-wne33u">
  <div class="MuiBox-root mui-style-1l5h1fr">
    <div class="MuiToolbar-root MuiToolbar-regular mui-style-1f2p3pb">
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 mui-style-1j2yjj3">
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7 mui-style-1m5ny0b">
          <div class="MuiBox-root mui-style-oc6i0x">
            <img
              alt="LA28 Logo"
              src="{{imagePath}}/assets/images/ole-la/Group_10642.svg"
            />              
          </div>
          <div class="header-lable">
            <h6>{{ 'Header' | clientTranslate }}</h6>
          </div>
        </div>
      </div>
      <div class="visaSecHeader">
        <img
          alt="VISA Dual Logo"
          src="{{imagePath}}/assets/images/ole-la/visa-dual-logo.svg"
        />
      </div>
    </div>
  </div>
  <div class="mui-style-1vk76n2">
    <span
      style="
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        width: 110px;
        height: 28px;
        background: none;
        opacity: 1;
        border: 0;
        margin: 0;
        padding: 0;
        position: relative;
      "
      >
      <img
        alt="VISA Dual Logo"
        src="{{imagePath}}/assets/images/ole-la/visa-dual-logo.svg"
      />
  </span>
    <p class="MuiTypography-root MuiTypography-body1 mui-style-s244od">
      The Official Way to Pay
    </p>
  </div>
</header>
